Object.defineProperty(exports,"__esModule",{value:true});var _defaults2=require("lodash/defaults");var _defaults3=_interopRequireDefault(_defaults2);
var _victoryCore=require("victory-core");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

{
getBaseProps:function getBaseProps(props,fallbackProps){var _this=this;
props=_victoryCore.Helpers.modifyProps(props,fallbackProps,"line");
var calculatedValues=this.getCalculatedValues(props);var
scale=calculatedValues.scale,data=calculatedValues.data,domain=calculatedValues.domain,style=calculatedValues.style;var _props=


props,interpolation=_props.interpolation,width=_props.width,height=_props.height,events=_props.events,sharedEvents=_props.sharedEvents,standalone=_props.standalone,groupComponent=_props.groupComponent,theme=_props.theme;
var initialChildProps={
parent:{style:style.parent,scale:scale,data:data,height:height,width:width,domain:domain,standalone:standalone},
all:{data:{scale:scale,data:data,interpolation:interpolation,groupComponent:groupComponent,theme:theme,style:style.data}}};

return data.reduce(function(childProps,datum,index){
var text=_this.getLabelText(props,datum,index);
if(text!==undefined&&text!==null||events||sharedEvents){
var eventKey=datum.eventKey||index;
childProps[eventKey]={labels:_this.getLabelProps(text,index,calculatedValues)};
}
return childProps;
},initialChildProps);
},

getCalculatedValues:function getCalculatedValues(props){
var data=_victoryCore.Data.getData(props);

if(data.length<2){
_victoryCore.Log.warn("VictoryLine needs at least two data points to render properly.");
data=[];
}

var range={
x:_victoryCore.Helpers.getRange(props,"x"),
y:_victoryCore.Helpers.getRange(props,"y")};

var domain={
x:_victoryCore.Domain.getDomain(props,"x"),
y:_victoryCore.Domain.getDomain(props,"y")};

var scale={
x:_victoryCore.Scale.getBaseScale(props,"x").domain(domain.x).range(range.x),
y:_victoryCore.Scale.getBaseScale(props,"y").domain(domain.y).range(range.y)};


var defaultStyles=props.theme&&props.theme.line&&props.theme.line.style?
props.theme.line.style:{};
var style=_victoryCore.Helpers.getStyles(props.style,defaultStyles,"auto","100%");

return{domain:domain,data:data,scale:scale,style:style};
},

getLabelText:function getLabelText(props,datum,index){
return datum.label||(Array.isArray(props.labels)?
props.labels[index]:props.labels);
},

getLabelProps:function getLabelProps(text,index,calculatedProps){var
scale=calculatedProps.scale,data=calculatedProps.data,style=calculatedProps.style;
var datum=data[index];var _getLabelPosition=
this.getLabelPosition(datum,scale),x=_getLabelPosition.x,y=_getLabelPosition.y;
var labelStyle=this.getLabelStyle(style)||{};
var sign=(datum._y1||datum._y)<0?-1:1;
return{
style:labelStyle,
x:x,
y:y-sign*(labelStyle.padding||0),
text:text,
index:index,
scale:scale,
datum:datum,
data:data,
textAnchor:labelStyle.textAnchor,
verticalAnchor:labelStyle.verticalAnchor||"end",
angle:labelStyle.angle};

},

getLabelPosition:function getLabelPosition(datum,scale){
return{
x:scale.x(datum._x1!==undefined?datum._x1:datum._x),
y:scale.y(datum._y1!==undefined?datum._y1:datum._y)};

},

getLabelStyle:function getLabelStyle(style){
var dataStyle=style.data||{};
var labelStyle=style.labels||{};

var opacity=dataStyle.opacity;


var fill=dataStyle.stroke;
var padding=labelStyle.padding||0;
return(0,_defaults3.default)({},labelStyle,{opacity:opacity,fill:fill,padding:padding});
}};


//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/lib/components/victory-line/helper-methods.js
// module id = 1358
// module chunks = 0